"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _core = require("@material-ui/core");

var _icons = require("@material-ui/icons");

var _styles = _interopRequireDefault(require("./styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SidebarNav = function SidebarNav(_ref) {
  var classes = _ref.classes,
      items = _ref.items,
      componentButton = _ref.componentButton,
      className = _ref.className,
      onClose = _ref.onClose,
      onClickItem = _ref.onClickItem,
      onClickLogout = _ref.onClickLogout,
      rest = _objectWithoutProperties(_ref, ["classes", "items", "componentButton", "className", "onClose", "onClickItem", "onClickLogout"]);

  return /*#__PURE__*/_react.default.createElement(_core.List, _extends({}, rest, {
    className: (0, _clsx.default)(classes.root, className)
  }), items.map(function (item) {
    return /*#__PURE__*/_react.default.createElement(_core.ListItem, {
      className: classes.item,
      disableGutters: true,
      key: item.title
    }, /*#__PURE__*/_react.default.createElement(_core.Button, {
      activeClassName: classes.active,
      component: componentButton,
      to: item.href,
      className: classes.button,
      onClick: function onClick(event) {
        return onClickItem(event, item);
      }
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: classes.icon
    }, item.icon), item.title));
  }), /*#__PURE__*/_react.default.createElement(_core.Hidden, {
    lgUp: true
  }, /*#__PURE__*/_react.default.createElement(_core.ListItem, {
    className: classes.item,
    disableGutters: true
  }, /*#__PURE__*/_react.default.createElement(_core.Button, {
    className: classes.button,
    onClick: onClickLogout
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.icon
  }, /*#__PURE__*/_react.default.createElement(_icons.InputOutlined, null)), "Sair"))));
};

SidebarNav.propTypes = {
  className: _propTypes.default.string,
  items: _propTypes.default.array.isRequired
};

var _default = (0, _core.withStyles)(_styles.default, {
  name: 'SidebarNav'
})(SidebarNav);

exports.default = _default;